import { jsx as _jsx } from "react/jsx-runtime";
import { CardContent } from './content';
import { CardHeader } from './header';
import { CardLabel } from './label';
import { cardStyling } from './styling';
import { cn } from '../../utils';
export function Card({ padding, rounding, className, children, }) {
    return (_jsx("div", { className: cn(cardStyling({ padding, rounding }), className), children: children }));
}
Card.Header = CardHeader;
Card.Content = CardContent;
Card.Label = CardLabel;
